import { Flex, useBreakpointValue, Box } from '@chakra-ui/react';
import Container from 'components/common/Container';
import { useState } from 'react';
import ProductPhotos from './ProductPhotos';
import ProductInfo from './ProductInfo';
import ProductPhotosMobile from './ProductPhotosMobile';
import GreyBox from 'components/common/GreyBox';
import RelativeItems from 'components/common/RelativesItems';
import useProduct from 'hooks/useProduct';
import BreadCrumb from 'components/common/BreadCrumb';
import StructuredDataJson from 'components/common/StructuredDataJson';
import MetaTagsHandler from '../common/MetaTagsHandler';
import { PhotoSwipe } from 'react-photoswipe';
import 'react-photoswipe/lib/photoswipe.css';

export default function ProductView({ product_id, breadcrumbs, isRing, ringSizeGuide, pageData }) {
  const { productData } = useProduct(product_id, { ...pageData });

  const [isOpen, setIsOpen] = useState(false);
  const [options, setOptions] = useState({ index: 0 });

  const handleCLose = () => {
    setIsOpen(false);
  };

  const items = productData?.productMedia.map((i) => {
    return {
      src: i.url,
      w: 1000,
      h: 1000,
    };
  });

  const handleZoom = (index) => {
    setOptions({ index: parseInt(index) });
    setIsOpen(true);
  };

  const productPhotos = useBreakpointValue({
    base: (
      <ProductPhotosMobile
        productMedia={productData?.productMedia}
        productTitle={productData?.title}
        handleZoom={handleZoom}
      />
    ),
    sm: (
      <ProductPhotosMobile
        productMedia={productData?.productMedia}
        productTitle={productData?.title}
        handleZoom={handleZoom}
      />
    ),
    md: (
      <ProductPhotosMobile
        productMedia={productData?.productMedia}
        productTitle={productData?.title}
        handleZoom={handleZoom}
      />
    ),
    lg: (
      <ProductPhotos
        productMedia={productData?.productMedia}
        productTitle={productData?.title}
        handleZoom={handleZoom}
      />
    ),
    xl: (
      <ProductPhotos
        productMedia={productData?.productMedia}
        productTitle={productData?.title}
        handleZoom={handleZoom}
      />
    ),
  });

  if (!pageData?.product_id) return null;

  return (
    <Container>
      {productData?.metaTags && <MetaTagsHandler metaTags={productData?.metaTags} />}
      {items && <PhotoSwipe isOpen={isOpen} items={items} onClose={handleCLose} options={options} />}

      <StructuredDataJson
        type={'Product'}
        productData={productData}
        title={productData?.title}
        body={productData?.body}
        id={productData?.product_id}
        description={productData?.body}
        code={productData?.master_sku}
        color={productData?.metal_colour?.name}
        size={productData?.size?.name}
      />
      <Box className="breadcrump" m={{ base: '20px 15px', md: '35px 15px', lg: '10px 15px' }}>
        <BreadCrumb breadcrumbs={breadcrumbs} />
      </Box>
      <Flex direction={['column', 'column', 'column', 'row']} padding="40px 0">
        {productPhotos}
        <ProductInfo
          productData={productData}
          product_id={product_id}
          metalColor={productData?.metal_colour}
          title={productData?.title}
          body={productData?.body}
          category={productData?.category?.name}
          weight={productData?.weight}
          availability={productData?.availability}
          variations={productData?.variations}
          defaultVariation={
            productData?.default_variation?.id ? productData?.default_variation : productData?.variations[0]
          }
          masterSku={productData?.master_sku}
          path={productData?.path}
          relativeColours={productData?.relativeColours}
          additionalInformation={productData?.additional_information}
          isRing={isRing}
          ringSizeGuide={ringSizeGuide}
        />
        {/* <div>
          <div className="klarna-widget" data-key="credit-promotion-badge" data-purchase-amount="5000"></div>
        </div> */}
      </Flex>
      <div id="sbl_recommendations" data-widget-type="product-recommendations" data-widget-uid="OjgEiy7jpnbt"></div>
      <div id="sbl_recommendations" data-widget-type="product-recommendations" data-widget-uid="6bMvVXmQcxly"></div>
      <GreyBox />
    </Container>
  );
}
